import { useQuery } from '@tanstack/react-query';
import { supabase } from '../utils/supabaseClient';

export function useFriends(currentUserId, blockedIds = []) {
  return useQuery({
    queryKey: ['friends', currentUserId],
    queryFn: async () => {
      const { data: allFriendships, error } = await supabase
        .from('friendships')
        .select('id, user_id, friend_id, status, accepted_at, created_at')
        .or(`user_id.eq.${currentUserId},friend_id.eq.${currentUserId}`);

      if (error) throw error;

      const accepted = (allFriendships || []).filter(f =>
        f.status === 'accepted' &&
        !blockedIds.includes(f.user_id === currentUserId ? f.friend_id : f.user_id)
      );
      const pendingReceived = (allFriendships || []).filter(f =>
        f.status === 'pending' &&
        f.friend_id === currentUserId &&
        !blockedIds.includes(f.user_id)
      );

      const involvedIds = new Set();
      (allFriendships || []).forEach(f => {
        involvedIds.add(f.user_id);
        involvedIds.add(f.friend_id);
      });

      let profileMap = {};
      if (involvedIds.size > 0) {
        const { data: profiles, error: profilesError } = await supabase
          .from('profiles')
          .select('*')
          .in('id', Array.from(involvedIds));
        if (profilesError) console.error('useFriends: 讀取 profiles 失敗', profilesError);
        (profiles || []).forEach(p => { profileMap[p.id] = p; });
      }

      const { data: eventsData } = await supabase
        .from('events')
        .select('id, organizer_id, title, date, event_participants(user_id)');

      const mapFriendship = f => ({
        _id: f.id,
        user: { _id: f.user_id, profile: profileMap[f.user_id] || null },
        friend: { _id: f.friend_id, profile: profileMap[f.friend_id] || null },
        status: f.status
      });

      return {
        friendships: accepted.map(mapFriendship),
        pendingRequests: pendingReceived.map(mapFriendship),
        events: eventsData || []
      };
    },
    enabled: !!currentUserId,
    staleTime: 2 * 60 * 1000, // 好友狀態異動較頻繁，縮短為 2 分鐘
  });
}
